import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getBudgetSelectors } from 'src/app/modules/collect-data/components/budget/store/budget.selectors';
import { IBudgetState } from 'src/app/modules/collect-data/components/budget/store/budget.state';
import { IWorkProposals } from 'src/app/modules/interfaces/work-proposals.interface';
import { setSettingsAction } from 'src/app/modules/settings/store/settings.actions';
import { getSettingsSelectors } from 'src/app/modules/settings/store/settings.selectors';
import { ISettingsState } from 'src/app/modules/settings/store/settings.state';
import { WorkProposalsService } from 'src/app/services/work-proposals.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-advisor',
  templateUrl: './advisor.component.html',
  styleUrls: ['./advisor.component.scss'],
})
export class AdvisorComponent implements OnInit {
  formsId: number;
  workProposalData: IWorkProposals = {
    id: 0,
    consultant_project_value: 0,
    followup_service: 0,
    default_pricing: 1,
    discount: 0,
    hide_deliverables: 0,
    installment: 0,
    rba_percentual: 0,
    type_of_investments_id: 0,
    type_of_payments_id: 0,
  };

  dataBudgetState$: Observable<IBudgetState>;
  dataBudgetState: IBudgetState;

  dataStoreSetting$: Observable<any>;
  dataStoreSetting: ISettingsState;

  isCreditCardSelected: boolean = false;
  isInCashSelected: boolean = false;

  financialConsultantValueBr: string = '';
  followUpServiceValueBr: string = '';
  advisorValueBr: string = '';
  advisorValueWithDiscountBr: string = '';
  advisorInstallmentValueBr: string = '';

  constructor(
    private store: Store,
    private workProposalsService: WorkProposalsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  async ngOnInit(): Promise<void> {
    await this.getBudgetState();
    await this.getState();
    await this.processingData();
  }

  loadWorkProposalsData() {
    this.workProposalsService
      .getWorkProposalsData(this.formsId)
      .subscribe((response) => {
        this.workProposalData = response;
        if (
          response.type_of_payments_id === 2 &&
          response.type_of_investments_id === 2
        ) {
          this.isInCashSelected = true;
          this.isCreditCardSelected = false;
          this.dataStoreSetting.jobOfferCardSelect = 'advisor in cash';
        } else if (
          response.type_of_payments_id === 1 &&
          response.type_of_investments_id === 2
        ) {
          this.isCreditCardSelected = true;
          this.isInCashSelected = false;
          this.dataStoreSetting.jobOfferCardSelect = 'advisor credit card';
        } else {
          this.isCreditCardSelected = false;
          this.isInCashSelected = false;
        }
        
        this.setState({ ...this.dataStoreSetting });
      });
  }

  getBudgetState() {
    this.dataBudgetState$ = this.store.select(getBudgetSelectors);
    this.dataBudgetState$.subscribe((value) => {
      this.dataBudgetState = { ...value };
    });
  }

  getState(): void {
    this.dataStoreSetting$ = this.store.select(getSettingsSelectors);
    this.dataStoreSetting$.subscribe((value) => {
      this.dataStoreSetting = {
        ...value,
      };

      if (
        this.dataStoreSetting.jobOfferCardSelect ==
          'financial consultant in cash' ||
        this.dataStoreSetting.jobOfferCardSelect ==
          'financial consultant credit card'
      ) {
        this.isInCashSelected = false;
        this.isCreditCardSelected = false;
      }
    });
    this.loadWorkProposalsData();
  }

  setState(data: ISettingsState): void {
    this.store.dispatch(setSettingsAction(data));
  }

  async processingData() {
    await this.validateFinancialConsultantValue();
    this.financialConsultantValueBr = this.formatToBRL(
      this.dataStoreSetting.financialConsultantValue
    );

    this.followUpServiceValueBr = this.formatToBRL(
      this.dataStoreSetting.followUpServiceValue
    );

    this.advisorValueBr = this.formatToBRL(this.dataStoreSetting.advisorValue);

    this.advisorValueWithDiscountBr = this.formatToBRL(
      this.dataStoreSetting.advisorValueWithDiscount
    );

    this.advisorInstallmentValueBr = this.formatToBRL(
      this.dataStoreSetting.installmentAdvisorValue
    );
    this.setState({ ...this.dataStoreSetting });
  }

  async validateFinancialConsultantValue() {
    let annualRecipeValue = this.dataBudgetState.annualRecipe;
    let totalValue =
      annualRecipeValue * (this.dataStoreSetting.percentValue / 100);

    if (totalValue > this.dataStoreSetting.manualValue) {
      this.dataStoreSetting.financialConsultantValue = totalValue;
    } else {
      this.dataStoreSetting.financialConsultantValue =
        this.dataStoreSetting.manualValue;
    }

    await this.validadeAdvisorValue();
    await this.updateCreditCardValues();
    await this.updateInCashValues();
  }

  validadeAdvisorValue(): void {
    this.dataStoreSetting.advisorValue =
      this.dataStoreSetting.financialConsultantValue +
      this.dataStoreSetting.followUpServiceValue;
     
  }

  updateCreditCardValues(): void {
    this.dataStoreSetting.installmentFinancialConsultantValue =
      this.dataStoreSetting.financialConsultantValue /
      this.dataStoreSetting.installments;
    this.dataStoreSetting.installmentAdvisorValue =
      this.dataStoreSetting.advisorValue / this.dataStoreSetting.installments;
  }

  updateInCashValues(): void {
    this.dataStoreSetting.financialConsultantValueWithDiscount =
      this.applyingDiscountPercentage(
        this.dataStoreSetting.percentualDiscount,
        this.dataStoreSetting.financialConsultantValue
      );
    this.dataStoreSetting.advisorValueWithDiscount =
      this.applyingDiscountPercentage(
        this.dataStoreSetting.percentualDiscount,
        this.dataStoreSetting.advisorValue
      );
  }

  applyingDiscountPercentage(percentage: number, value: number): number {
    if (percentage < 0 || percentage > 100) {
      return value;
    }
    if (value < 0) {
      return value;
    }
    const discount = (percentage / 100) * value;
    const discountedValue = value - discount;
    return discountedValue;
  }

  creditCardSelected() {
    this.isInCashSelected = false;
    if (this.isCreditCardSelected) {
      this.dataStoreSetting.jobOfferCardSelect = 'advisor credit card';
    } else {
      this.dataStoreSetting.jobOfferCardSelect = '';
    }
    this.setState(this.dataStoreSetting);

    const updateData: Partial<IWorkProposals> = {
      type_of_payments_id: 1,
      type_of_investments_id: 2,
    };
    this.workProposalsService
      .updateWorkProposalsData(
        this.formsId,
        this.workProposalData.id,
        updateData
      )
      .subscribe();
  }

  inCashSelected() {
    this.isCreditCardSelected = false;
    if (this.isInCashSelected) {
      this.dataStoreSetting.jobOfferCardSelect = 'advisor in cash';
    } else {
      this.dataStoreSetting.jobOfferCardSelect = '';
    }

    this.setState(this.dataStoreSetting);

    const updateData: Partial<IWorkProposals> = {
      type_of_payments_id: 2,
      type_of_investments_id: 2,
    };
    this.workProposalsService
      .updateWorkProposalsData(
        this.formsId,
        this.workProposalData.id,
        updateData
      )
      .subscribe();
  }

  formatToBRL(value: number) {
    let response = Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(Number(value));

    return response;
  }
}
